import { Link } from '@material-ui/core';
import React from 'react';
import { AnimalIdLinkProps } from './animal-id-link-props';
import './animal-id-link.scss';

/**
 * A link to the animal details page.
 * @param props
 */
export const AnimalIdLink: React.FC<AnimalIdLinkProps> = (props) => {
  const {
    id,
    label,
    asbvs,
    database,
    trait,
    bold = true,
  } = props;

  let href = `/animal/${id}?db=${database}`;
  if (trait) {
    href += `&scenario=${trait}`;
  }

  if (asbvs?.length && typeof asbvs !== 'string') {
    href += `&asbvs=${asbvs.map((asbv) => asbv.asbvId).toString()}`;
  } else if (asbvs?.length) {
    href += `&asbvs=${asbvs}`;
  }

  const style:React.CSSProperties = bold ? { textDecoration: 'underline' } : { fontSize: '0.875rem', textDecoration: 'underline' };
  return (
    <Link
      style={style}
      href={href}
      target="_blank"
    >
      {label}
    </Link>
  );
};
